import { render } from "./404.vue?vue&type=template&id=9307aac2&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=9307aac2&lang=less&scoped=true"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9307aac2"]])

export default __exports__